/* Los dos movimientos de la tanda 2. Sin librería: 11 de 15 sitios de premio
   corren sin ninguna, y lo que hay aquí no la justifica. */
document.documentElement.classList.add('js');

/* ── el trazo que se dibuja ──────────────────────────────────────────────────
   El largo del trazo se MIDE, no se adivina: un dasharray a ojo deja la onda
   cortada o con un salto al final. */
document.querySelectorAll('.trazo').forEach(svg => {
  const d = svg.querySelector('path');
  svg.style.setProperty('--largo', Math.ceil(d.getTotalLength()));
  new IntersectionObserver((e, o) => {
    if (e[0].isIntersecting) { svg.classList.add('dibuja'); o.disconnect(); }
  }, { threshold: .6 }).observe(svg);
});

/* ── las siete marcas de la biblioteca, dibujándose ──────────────────────────
   Mismo gesto que el trazo de arriba, pero SIN medir: el contenido de un <use>
   vive en un árbol sombra y `getTotalLength()` no lo alcanza. El guion va en el
   <svg> —`stroke-dasharray` se hereda— con un largo fijo que cubre al trazo más
   largo. Todo eso vive en el CSS; aquí solo se dice cuándo.

   Se dispara UNA vez y se desconecta: es un dibujo, no un medidor de scroll.
   Volver a dibujarlo al subir sería el sitio rehaciéndose delante de alguien que
   ya lo leyó. */
document.querySelectorAll('.indice').forEach(idx => {
  new IntersectionObserver((e, o) => {
    if (e[0].isIntersecting) { idx.classList.add('dibuja'); o.disconnect(); }
  }, { threshold: .25 }).observe(idx);
});

/* ── el agua de la biblioteca, a la deriva ───────────────────────────────────
   Un solo número, --deriva de -1 a 1, y el movimiento lo hace el CSS. Es el
   mismo patrón que el resto del sitio.
   Sirve para una cosa concreta: que la costura entre el manifiesto y esta
   sección no sea una línea quieta. Un borde inmóvil mientras la página se mueve
   es exactamente lo que hace que un corte se lea a corte. */
const lib = document.getElementById('library');
if (lib && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
  let pl = false;
  function deriva() {
    pl = false;
    const r = lib.getBoundingClientRect();
    if (r.bottom < 0 || r.top > innerHeight) return;
    // -1 cuando la sección entra por abajo, +1 cuando termina de salir por
    // arriba. Anclado al CENTRO de la sección para que el recorrido sea simétrico
    // y no dependa de lo alta que sea.
    const d = (innerHeight / 2 - (r.top + r.height / 2)) / (innerHeight / 2 + r.height / 2);
    lib.style.setProperty('--deriva', Math.max(-1, Math.min(1, d)).toFixed(3));
  }
  addEventListener('scroll', () => {
    if (!pl) { pl = true; requestAnimationFrame(deriva); }
  }, { passive: true });
  addEventListener('resize', deriva, { passive: true });
  deriva();
}

/* ── las pegatinas que flotan ────────────────────────────────────────────────
   Se mueven POCO: el paralaje que se nota es el que estorba.
   El recorte de "¿está a la vista?" va DENTRO de mueve(), no en un observador
   que enciende y apaga el listener: con el candado fuera, la posición se
   quedaba pegada entre dos puntos de scroll y el movimiento salía a saltos. */
const quieto = matchMedia('(prefers-reduced-motion: reduce)').matches;
const pegs = [...document.querySelectorAll('.pegado')];
if (pegs.length && !quieto) {
  let pedido = false;

  function mueve() {
    pedido = false;
    // 🔴 El recorte de visibilidad va POR PIEZA. Estaba colgado de
    // `pegs[0].closest('section')`: una sola sección mandaba sobre todas, así que
    // al sumar pegatinas en §4 el listener decidía si calcularlas mirando dónde
    // estaba el manifiesto. Mientras vivieron todas en la misma sección no se
    // notaba — es la clase de suposición que aguanta hasta que dejas de cumplirla.
    pegs.forEach(el => {
      const b = el.getBoundingClientRect();
      if (b.bottom < -200 || b.top > innerHeight + 200) return;
      // Cada pegatina se mide a SÍ MISMA, no a la sección. Colgado del alto de la
      // sección el recorrido salía de ±4 px —el manifiesto mide dos pantallas— y
      // el paralaje no se veía. Anclado a la pieza, q va de +.5 (entrando por
      // abajo) a -.5 (saliendo por arriba) sin importar cuán alta sea la sección.
      const q = (innerHeight / 2 - (b.top + b.height / 2)) / innerHeight;
      el.style.transform = `translateY(${(q * 150 * +el.dataset.vel).toFixed(1)}px)`;
    });
  }
  addEventListener('scroll', () => {
    if (!pedido) { pedido = true; requestAnimationFrame(mueve); }
  }, { passive: true });
  addEventListener('resize', mueve, { passive: true });
  mueve();
}


/* ── §4 SE ASIENTA ──────────────────────────────────────────────────────────
   La lámina del planner baja sus últimos 22 px y abre su sombra conforme entra.
   Un solo número otra vez —`--p` de 0 a 1— y todo el movimiento en CSS.
   El tramo es la ENTRADA, no la sección completa: `--p` llega a 1 cuando la
   tarjeta ya está bien dentro de la pantalla. Si se colgara del alto entero, la
   sombra seguiría creciendo mientras lees la ficha, que es movimiento sin
   motivo — y a esa distancia ya nadie lo lee como que se está apoyando. */
const laminaPl = document.querySelector('#planner');
if (laminaPl && !quieto) {
  let pedidoPl = false;
  function asienta() {
    pedidoPl = false;
    const r = laminaPl.getBoundingClientRect();
    // 🔴 Solo se sale cuando ya QUEDÓ ARRIBA (ahí --p vale 1 y se queda). Si
    // también se saliera con la sección abajo, en la carga se quedaría en su
    // valor de reposo —1, asentada— y al entrar saltaría de golpe a 0 para
    // volver a subir. El recorte de abajo lo hace el clamp, gratis.
    if (r.bottom < 0) return;
    const p = Math.max(0, Math.min(1, (innerHeight - r.top) / (innerHeight * .62)));
    laminaPl.style.setProperty('--p', p.toFixed(3));

    /* 🔴 `--q` ES OTRO NÚMERO, Y TIENE QUE SERLO. `--p` mide la ENTRADA: llega a 1
       en el primer 62% de la pantalla y ahí se queda clavado —correcto para una
       tarjeta que se asienta y ya—. Colgar la luz de él la habría hecho barrer
       durante la entrada para congelarse justo durante todo el rato que estás
       leyendo la ficha: el fondo se apagaría exactamente cuando lo estás mirando.
       `--q` es la TRAVESÍA COMPLETA: 0 cuando la sección asoma por abajo, 1 cuando
       termina de salir por arriba. Se mide contra `innerHeight + alto`, que es la
       distancia real que recorre.
       El `return` de arriba (`r.bottom < 0`) también corta esta línea, así que con
       la sección ya fuera por arriba `--q` se queda en el último valor escrito —
       que a esa altura vale ~1 igual, o sea el mismo sitio donde lo dejaría el
       clamp. Se comparte el `return` a propósito: son dos números del mismo objeto
       y separarlos costaría un segundo `getBoundingClientRect` por cuadro. */
    const q = Math.max(0, Math.min(1, (innerHeight - r.top) / (innerHeight + r.height)));
    laminaPl.style.setProperty('--q', q.toFixed(4));
  }
  addEventListener('scroll', () => {
    if (!pedidoPl) { pedidoPl = true; requestAnimationFrame(asienta); }
  }, { passive: true });
  addEventListener('resize', asienta, { passive: true });
  asienta();
}


/* ── §3 SE ARMA AL SALIR DEL PAPEL ──────────────────────────────────────────
   Lo que paco pedía: que de la flor a §3 hubiera una transición, no un corte.
   Lo que había: la marea de papel tapaba la flor y, al soltar, §3 ya estaba
   montada. Medido — con la píldora todavía a 811 px, o sea casi fuera de la
   pantalla, ya tenía puesta su clase.

   🔴 Y el primer arreglo también estuvo mal, por la misma razón que el anterior:
   colgué la llegada de §3 del --p del valle, para que la marea la trajera. Suena
   bien y se mide mal: mientras el valle está ANCLADO, §3 está entera debajo del
   pliegue —al soltarse las palabras, la píldora estaba en 1049 px con una
   ventana de 900—. Otra vez armándose a ciegas.
   La continuidad no se consigue atando §3 al valle, sino haciendo que §3 se
   arme JUSTO AL EMERGER del papel: el recorrido cuelga de su propia posición y
   arranca cuando su cabeza asoma por el borde inferior. La marea entrega la
   hoja; la hoja trae el texto encima. Un solo movimiento, y visible. */
const cabeza = document.querySelector('.elige .cabeza');
if (cabeza && !quieto) {
  let pc = false;
  function emerge() {
    pc = false;
    const r = cabeza.getBoundingClientRect();
    if (r.top > innerHeight) { cabeza.style.setProperty('--llega', '0'); return; }
    if (r.bottom < 0) return;                 // ya pasó: se queda armada
    /* De 0 cuando la cabeza asoma por abajo, a 1 cuando ha subido el 52% de la
       ventana. Ese tramo es el que se ve: ni antes (fuera de cuadro) ni después
       (ya la estás leyendo). */
    const l = Math.max(0, Math.min(1, (innerHeight - r.top) / (innerHeight * .52)));
    cabeza.style.setProperty('--llega', l.toFixed(3));
  }
  addEventListener('scroll', () => {
    if (!pc) { pc = true; requestAnimationFrame(emerge); }
  }, { passive: true });
  addEventListener('resize', emerge, { passive: true });
  emerge();
}


/* ── EL VIAJE POR EL CAMPO DE PROFUNDIDAD ────────────────────────────────────
   Mismo mecanismo que todo lo demás del sitio: UN número, --p (0 → 1), sacado
   de cuánto lleva recorrido la sección. De ahí cuelgan las diez piezas en Z y
   la llegada del titular. El movimiento lo hace el CSS; esto solo dice dónde
   está el dedo.

   🔴 Nada de rect por elemento aquí: las piezas viven dentro de un sticky y
   ahí su rect deja de cambiar (se queda clavado), así que un paralaje medido
   pieza por pieza se congelaría. Todo cuelga del --p de la sección. */
const valle = document.getElementById('universo');
if (valle && !quieto) {
  let pv = false;

  function viaja() {
    pv = false;
    const r = valle.getBoundingClientRect();
    if (r.bottom < 0 || r.top > innerHeight) return;
    const recorrido = valle.offsetHeight - innerHeight;
    const p = Math.max(0, Math.min(1, -r.top / recorrido));
    valle.style.setProperty('--p', p.toFixed(4));
  }
  /* ── EL SEGUNDO TIEMPO ES CSS PURO ────────────────────────────────────────
     🔴 AQUÍ VIVÍAN 60 LÍNEAS: un lienzo, 26 cuadros de la flor de papel, un
     IntersectionObserver que los pedía y un lector que sacaba el tramo del CSS
     para que los dos lados no se desincronizaran. Ella pidió quitar la flor y
     poner sus planners y journals, y el ramo que la sustituye se mueve entero
     con `--b` en la hoja de estilo. No hay cuadro que dibujar.

     Lo que se fue con ella: 552 KB de secuencia, un canvas repintándose por
     scroll, y el tramo duplicado en dos archivos. El `--p` de esta función es
     ahora lo único que la sección necesita.                                 */

  addEventListener('scroll', () => {
    if (!pv) { pv = true; requestAnimationFrame(viaja); }
  }, { passive: true });
  addEventListener('resize', viaja, { passive: true });
  viaja();
}


/* ── LA CITA QUE SE ENCIENDE AL BAJAR ────────────────────────────────────────
   Mismo mecanismo determinista que la entrada del sitio: una variable del scroll,
   cero librería y cero pin de GSAP (el pin mete deriva cuando algo se mueve
   dentro). Determinista además quiere decir que se puede fijar a mano y
   capturar, que es como se verifica.

   Se enciende Y SE APAGA, o sea funciona igual subiendo — que es lo pedido. */
const suena = document.getElementById('suena');
if (suena && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const ws = [...suena.querySelectorAll('.w')];

  /* El trazo bajo "eligiendo". Mismo principio que las ondas de la tanda 2: el
     largo se MIDE, no se adivina. La diferencia es que este no se dispara al
     entrar en pantalla — se dibuja colgado de --p, o sea con el scroll. */
  const raya = suena.querySelector('.subraya path');
  if (raya) {
    const pon = () => raya.style.setProperty('--largo',
      Math.ceil(raya.getTotalLength()));
    pon();
    addEventListener('resize', pon, { passive: true });
    if (document.fonts) document.fonts.ready.then(pon);
  }
  let pide = false;

  function pinta() {
    pide = false;
    const r = suena.getBoundingClientRect();
    const recorrido = suena.offsetHeight - innerHeight;
    // 0 al entrar, 1 cuando la sección termina de pasar
    const p = Math.max(0, Math.min(1, -r.top / recorrido));
    suena.style.setProperty('--p', p.toFixed(4));
    // Las palabras ocupan el 12%-72% del recorrido. Arrancan antes que en la
    // primera versión (era 20%-78%) porque ahora ENTRAN desde su máscara en vez
    // de encender de .16: apagada la palabra ya no se adivina, así que esperar
    // deja la lámina con un hueco vacío. Del 72% al 90% se dibuja el trazo bajo
    // "eligiendo" —el clímax— y el resto es el respiro antes de soltar.
    const t = (p - .12) / .60;
    const n = Math.round(t * ws.length);
    ws.forEach((w, i) => w.classList.toggle('on', i < n));
  }
  addEventListener('scroll', () => {
    if (!pide) { pide = true; requestAnimationFrame(pinta); }
  }, { passive: true });
  addEventListener('resize', pinta, { passive: true });
  pinta();
}

/* ═══ LA PILA · el progreso de sección y el rótulo que cambia de color ══════
   Un solo `--p` para las ocho portadas: el CSS deriva de ahí el estado de cada
   una con su `--i`. Aquí solo se actualiza el nombre y el color del rótulo, que
   es la parte que el CSS no puede hacer sola porque implica cambiar TEXTO.

   🔴 Sin JS la pila NO se rompe: con `--p:0` la primera portada está PUESTA y
   las otras siete esperan debajo del marco. Eso no salió gratis — la primera
   versión nacía con las ocho en opacidad 0 y solo aparecían cuando el JS
   escribía el primer `--p`; se cazó midiendo, no mirando. Ver el `+1` del
   `--q` en pagina.css. Y quien pide movimiento reducido recibe la rejilla
   completa de ocho por CSS. */
const pila = document.getElementById('pila');
if (pila && !quieto) {
  const figs   = [...pila.querySelectorAll('.pl')];
  const nom    = document.getElementById('pl-nom');
  const col    = document.getElementById('pl-col');
  const placa  = document.getElementById('pl-placa');
  const num    = document.getElementById('pl-num');
  const tintes = ['cobalto','orquidea','lima','terracota','esmeralda'];
  /* El TOTAL lo cuenta el DOM, no lo escribe una persona. Un "08" a mano en el
     HTML sigue diciendo ocho el día que se añada o se quite una portada, y un
     contador que miente es peor que no tenerlo. */
  const tot = document.getElementById('pl-tot');
  if (tot) tot.textContent = String(figs.length).padStart(2, '0');
  let pp = false, ultimo = -1;

  function apila() {
    pp = false;
    const r = pila.getBoundingClientRect();
    if (r.bottom < 0 || r.top > innerHeight) return;
    const recorrido = pila.offsetHeight - innerHeight;
    const p = Math.max(0, Math.min(1, -r.top / recorrido));
    pila.style.setProperty('--p', p.toFixed(4));

    /* 🔴 LA QUE MANDA ES LA DE ENCIMA, y hay que SACARLA DE LA MISMA FÓRMULA
       QUE EL CSS o el rótulo miente. La primera versión usaba
       `floor(p * n)` —una aproximación razonable— y a mitad de la sección el
       texto decía "Infinite Possibilities · LIMA" mientras arriba de la pila
       estaba el COBALTO. No da error, no se ve en el código: solo se caza
       leyendo el rótulo contra la portada en una captura.
       En el CSS cada portada entra cuando `p*(n-1) - i + 1 > 0`, así que la
       última que ha entrado es `floor(p*(n-1) + 1)`.

       🔴 v3 — EL UMBRAL ERA UN EPSILON Y TENÍA QUE SER EL DE LA OPACIDAD.
       Con `- 1e-6`, el índice 0 existía SOLO en `p=0` exacto: al primer píxel de
       scroll el rótulo ya decía "02" mientras la portada 2 estaba al 24% y la
       que mandaba en el cuadro seguía siendo la primera. O sea el estado
       "01 · La Planner 2027" no se veía NUNCA.
       Es un defecto viejo, no del recorte: con ocho piezas pasaba igual, pero el
       instante perdido se repartía entre siete turnos y no se notaba; con tres
       turnos salta a la vista. Se cazó leyendo el rótulo contra las opacidades
       en un barrido de scroll, no en el código — como las dos veces anteriores.
       El umbral correcto no es un epsilon: es `.18`, EL MISMO NÚMERO con el que
       el CSS resuelve `--o`. Una portada manda cuando está sólida, no cuando
       asoma. Sacar el número de la misma constante que el CSS es lo que impide
       que el rótulo y el cuadro vuelvan a decir cosas distintas. */
    const N = figs.length;
    const SOLIDA = .18;
    const i = Math.max(0, Math.min(N - 1, Math.floor(p * (N - 1) + 1 - SOLIDA)));
    if (i === ultimo) return;
    ultimo = i;
    const f = figs[i];
    const t = [...f.classList].find(c => c.startsWith('pl-'))?.slice(3);
    nom.textContent = f.querySelector('b').textContent;
    col.textContent = f.querySelector('figcaption span').textContent;
    /* El contador sale del MISMO índice que el rótulo, no de un cálculo aparte.
       Si tuviera su propia fórmula acabaría diciendo "03" mientras el rótulo
       nombra la cuarta — que es exactamente el desajuste que ya se cazó aquí
       leyendo el rótulo contra la portada, no el código. */
    if (num) num.textContent = String(i + 1).padStart(2, '0');
    if (t) {
      /* Apunta a la TINTA del color, no al color: la lima mide 2.18 como texto
         y su tinta legible es el oliva hondo. El mapeo vive en el CSS, junto
         a los demás pares medidos. */
      pila.style.setProperty('--tinte-activo', `var(--tinta-${t})`);
      /* La placa del titular se pinta con el mismo tinte, así que el sistema de
         color y la pila dicen lo mismo al mismo tiempo. Se cambia la clase, no
         el color en línea: los cinco pares fondo/texto ya están medidos ahí. */
      /* 🔴 EL PREFIJO ES `realce-`, NO `placa-`. La clase del acento se renombró
         porque `.placa` ya era la placa de la FOTO del hero, con overflow:hidden,
         y le recortaba los glifos. Este es el efecto secundario clásico de
         renombrar: el CSS queda bien y el JS sigue escribiendo el nombre viejo
         SIN ERROR — la clase simplemente no existe y el color se queda en el
         estático. Se cazó midiendo el hex de la placa, no leyendo el archivo. */
      tintes.forEach(x => placa.classList.remove('realce-' + x));
      placa.classList.add('realce-' + t);
    }
  }
  addEventListener('scroll', () => { if (!pp) { pp = true; requestAnimationFrame(apila); } }, { passive:true });
  addEventListener('resize', apila, { passive:true });
  apila();
}

/* ═══ EL MOSTRADOR · §tienda ════════════════════════════════════════════════
   Tres cosas, y las tres tienen que sobrevivir sin JS:
     · `--p` de la sección → mueve la fibra de la mesa. Sin JS se queda en .5,
       que es el centro del recorrido: la fibra existe igual, quieta.
     · el giro con el puntero → escribe `--rx`/`--ry`. Sin JS valen 0.
     · el color vivo de la Planner → sin JS la ficha enseña el cobalto y sus
       cuatro muestras siguen siendo botones que no hacen nada. Por eso el
       nombre del color va como TEXTO en el HTML y no lo escribe el JS al
       arrancar: una ficha que dice su color aunque el script falle. */
const tienda = document.getElementById('tienda');
if (tienda && !quieto) {
  let pt = false;
  function mesa() {
    pt = false;
    const r = tienda.getBoundingClientRect();
    if (r.bottom < 0 || r.top > innerHeight) return;
    /* La misma fórmula que el `--q` de §planner: 0 cuando la sección viene
       entrando por abajo, 1 cuando acaba de salir por arriba. Sirve para
       secciones CORTAS —ésta mide menos de una pantalla—, donde la fórmula de
       §pila (`-top / (alto - viewport)`) daría un denominador negativo. */
    const p = Math.max(0, Math.min(1, (innerHeight - r.top) / (innerHeight + r.height)));
    tienda.style.setProperty('--p', p.toFixed(4));
  }
  addEventListener('scroll', () => { if (!pt) { pt = true; requestAnimationFrame(mesa); } }, { passive:true });
  addEventListener('resize', mesa, { passive:true });
  mesa();

  /* ── el giro con el puntero ──────────────────────────────────────────────
     🔴 SOLO CON PUNTERO FINO. En táctil no hay hover: el navegador emula uno
     al tocar y la hoja se quedaría girada hasta que toques otra cosa. Y sin
     `hover:hover` un `mousemove` en móvil dispara igual con el toque.
     2.2° de amplitud, no los 15 del snippet de tilt-card: a quince grados una
     hoja de papel se lee a naipe. */
  if (matchMedia('(hover:hover) and (pointer:fine)').matches) {
    const TOPE = 2.2;
    tienda.querySelectorAll('.sku').forEach(hoja => {
      let ph = false, ex = 0, ey = 0;
      const pinta = () => {
        ph = false;
        hoja.style.setProperty('--ry', (ex * TOPE).toFixed(2) + 'deg');
        hoja.style.setProperty('--rx', (ey * -TOPE).toFixed(2) + 'deg');
      };
      hoja.addEventListener('pointermove', e => {
        /* 🔴 EL GIRO SE CONGELA SOBRE LOS CONTROLES, Y ESTO NO ES UN DETALLE DE
           PULIDO: ERA EL BUG. paco, tres veces: *"no se pone color naranja y no
           me deja clickear"*.
           La causa es este mismo `pointermove`: repinta el giro en CADA
           movimiento del ratón, así que la tarjeta —y el botón que lleva
           dentro— **no se está quieta nunca** mientras el cursor se mueve
           encima. Dos consecuencias, que son exactamente las dos que él
           describe:
           · El navegador solo emite `click` si `pointerdown` y `pointerup`
             caen sobre el mismo elemento. Con el botón moviéndose bajo el dedo,
             **el clic no llega**. No es que falle a veces: es que no existe.
           · Y con el `transform` 3D del ancestro, el centro de la caja del
             enlace deja de caer sobre el enlace: medido con el cursor puesto en
             el centro del botón, `elementFromPoint` devolvía `div.ficha-tx` y
             `a.matches(':hover')` daba **false** — de ahí que no se pinte de
             naranja.
           Congelar (no devolver a cero: eso también lo movería) deja la hoja
           exactamente donde estaba en el instante en que el cursor tocó el
           control. El giro se conserva en el resto de la tarjeta, que es donde
           significa algo: sobre el producto. */
        if (e.target instanceof Element && e.target.closest('a[href], button')) return;
        const b = hoja.getBoundingClientRect();
        ex = (e.clientX - b.left - b.width / 2)  / (b.width / 2);
        ey = (e.clientY - b.top  - b.height / 2) / (b.height / 2);
        if (!ph) { ph = true; requestAnimationFrame(pinta); }
      }, { passive:true });
      /* Al salir se devuelve a cero con la curva larga de la ficha, no con la
         corta del seguimiento: entrar tiene que ser inmediato y salir tiene que
         asentarse. Por eso el `transition` corto vive en `.sku:hover`. */
      hoja.addEventListener('pointerleave', () => {
        ex = ey = 0;
        hoja.style.setProperty('--ry', '0deg');
        hoja.style.setProperty('--rx', '0deg');
      });
    });
  }
}

/* ── los cuatro colores de la Planner, vivos ───────────────────────────────
   "4 colores" era texto muerto: el dato estaba escrito y los cuatro recortes
   llevaban meses en disco sin que nadie los pudiera ver.
   Corre AUNQUE se pida movimiento reducido: elegir un color no es movimiento,
   es información, y quitársela a quien pide menos animación sería castigarlo. */
const muestrario = document.querySelector('.tienda .colores-sku');
if (muestrario) {
  const ficha  = muestrario.closest('.sku');
  const objeto = ficha.querySelector('.sku-obj');
  const suelo  = ficha.querySelector('.sku-sombra');
  const nombre = ficha.querySelector('.color-vivo');
  /* Las cuatro portadas se precargan al primer toque del ratón sobre la ficha,
     no al cargar la página: cuatro webp de 260 KB compitiendo con el hero por
     el ancho de banda es justo lo que hace lento un sitio que se ve rápido. */
  let cargadas = false;
  ficha.addEventListener('pointerenter', () => {
    if (cargadas) return; cargadas = true;
    muestrario.querySelectorAll('button').forEach(b => {
      new Image().src = b.dataset.obj;
      new Image().src = b.dataset.sombra;
    });
  }, { once:true });

  muestrario.addEventListener('click', e => {
    const b = e.target.closest('button');
    if (!b || b.getAttribute('aria-pressed') === 'true') return;
    muestrario.querySelectorAll('button')
      .forEach(x => x.setAttribute('aria-pressed', String(x === b)));
    objeto.src = b.dataset.obj;
    suelo.src  = b.dataset.sombra;
    /* La sombra cambia CON la portada, no se queda la del cobalto: cada
       variante se renderizó en su propia pasada y su mancha no es la misma.
       Es el mismo error que tenía la fila entera antes de esta tanda —una
       sombra genérica para cinco objetos— repetido a menor escala. */
    objeto.alt = 'Planner 2027 en color ' + b.dataset.color;
    nombre.textContent = b.dataset.color;
    ficha.style.setProperty('--tinte', b.dataset.tinte);
  });
}

/* ═══ §VOCES · el paralaje por columna ══════════════════════════════════════
   Un solo `--pv` para la sección y el CSS reparte: la columna 1 sube, la 3
   baja y la 2 se queda quieta de referencia. Sin JS vale .5 —el centro del
   recorrido— así que el muro se ve completo y a nivel, que es el reposo
   correcto. */
const voces = document.getElementById('voces');
if (voces && !quieto) {
  let pv = false;
  function mueve() {
    pv = false;
    const r = voces.getBoundingClientRect();
    if (r.bottom < 0 || r.top > innerHeight) return;
    const p = Math.max(0, Math.min(1, (innerHeight - r.top) / (innerHeight + r.height)));
    voces.style.setProperty('--pv', p.toFixed(4));
  }
  addEventListener('scroll', () => { if (!pv) { pv = true; requestAnimationFrame(mueve); } }, { passive:true });
  addEventListener('resize', mueve, { passive:true });
  mueve();
}

/* ── LA DERIVA DE LOS HALOS DE SECCIÓN ──────────────────────────────────────
   Los halos de color (`.halo-sec`) se mueven con el recorrido de su sección por
   la pantalla. El reposo sin JS es `--p:.5`, o sea deriva CERO y el halo puesto:
   sin JS la sección se ve bien, que es la regla de todo el sitio.

   🔴 #tienda SE EXCLUYE A PROPÓSITO: ya escribe su propio `--p` unas líneas más
   arriba (para la fibra del mostrador). Dejar que este bloque se lo escribiera
   también sería el error que este archivo ya documenta tres veces — dos dueños
   para la misma propiedad—, y aquí sería peor por silencioso: la fórmula es la
   MISMA, así que el valor coincidiría y nadie notaría el conflicto hasta que
   alguien cambiara uno de los dos.

   Un solo observador de scroll para las tres, no uno por sección: cada listener
   suma trabajo al hilo principal en el evento más caliente de la página. */
if (!quieto) {
  const conHalo = [...document.querySelectorAll('.halo-sec')]
    .map(h => h.parentElement)
    .filter(s => s && s.id !== 'tienda');
  if (conHalo.length) {
    let ph = false;
    const halos = () => {
      ph = false;
      conHalo.forEach(s => {
        const r = s.getBoundingClientRect();
        if (r.bottom < 0 || r.top > innerHeight) return;
        const p = Math.max(0, Math.min(1, (innerHeight - r.top) / (innerHeight + r.height)));
        s.style.setProperty('--p', p.toFixed(4));
      });
    };
    addEventListener('scroll', () => { if (!ph) { ph = true; requestAnimationFrame(halos); } }, { passive:true });
    addEventListener('resize', halos, { passive:true });
    halos();
  }
}

/* ── LA FIRMA DE §MANIFIESTO ────────────────────────────────────────────────
   Mismo patrón que `.trazo` y `.indice`: se dispara una vez y se desconecta.
   NO se revierte al salir, a diferencia del revelado general — una firma que se
   borra y se vuelve a escribir cada vez que pasas por encima deja de leerse a
   firma y se lee a animación. Se firma una vez.
   El umbral es alto (.9) porque el pie del retrato es un elemento chico al final
   de una foto alta: con el umbral por defecto se dispararía mientras todavía
   está entrando y el trazo se gastaría fuera de cuadro. */
/* 🔴🔴 SE OBSERVA EL PADRE, NO LA FIRMA — Y LA RAZÓN ES UNA TRAMPA NUEVA:
   **`IntersectionObserver` SÍ tiene en cuenta el `clip-path`.** La firma nace con
   `clip-path: inset(0 100% ...)`, o sea con área visible cero, así que el
   observador puesto sobre ella devolvía `intersectionRect: 0x0` y `ratio: 0` con
   el elemento perfectamente dentro de la pantalla (medido: caja 83x30, top 435,
   viewport 900). Nunca disparaba.
   Es un bucle cerrado: **el estado inicial de la animación esconde el elemento
   del disparador que debía lanzarla.** No da error, no se ve en el código, y
   parece un fallo del umbral — subirlo o bajarlo no habría arreglado nada porque
   el ratio era 0, no 0.4.
   Vale para cualquier animación que arranque desde `clip-path`, `scale(0)` o
   `width:0`: el gancho va en un ancestro SIN recortar. */
document.querySelectorAll('.rubrica').forEach(r => {
  const gancho = r.parentElement || r;
  new IntersectionObserver((e, o) => {
    if (e[0].isIntersecting) { r.classList.add('escrita'); o.disconnect(); }
  }, { threshold: .9 }).observe(gancho);
});
